import { useQuery } from "@tanstack/vue-query";
import { ledgerCreditsQuery } from "@vendata/power-up-sdk/requests/credits/ledger";

export function useCreditLoader() {
  return {
    ledgerQuery: useQuery(ledgerCreditsQuery()),
  };
}
